import { Injectable } from "@angular/core";
import { DynamicConfig } from "@statsig/js-client";

import { StatsigService } from '../statsig.service';

import { HighlighterMap } from '../statsig-overlay.interface';

export const CONFIG_NAME = 'statsig-overlay-ui-highlight-xpaths';

@Injectable({ providedIn: 'root'})
export class StatsigOverlayHighlightConfig {
  private highlighterEntries: DynamicConfig;

  constructor(
    private statsigService: StatsigService,
  ) {
    this.highlighterEntries = this.statsigService.evaluateDynamicConfig(CONFIG_NAME);
  }

  public getHighlighterData(): HighlighterMap {
    return this.highlighterEntries.value as HighlighterMap;
  } 
}
